import { Divider, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import React from "react";

const details = [
  {
    label: "Source table",
    value: "raw_website_clicks_in_out",
    info: "",
    bold: "",
  },
  {
    label: "Unique key",
    value: "id",
    info: "row primary key — one row per click-out event",
  },
  {
    label: "Timestamp column",
    value: "clickin_timestemp_utc",
    info: "UTC; note: column name typo is in the DB",
  },
  {
    label: "Date grouping",
    value: "date_of_acquisition",
    info: "day-level, always midnight",
  },
  {
    label: "Aggregation",
    value: "COUNT(id) WHERE count_as_click_in_out = 1",
    info: "",
  },
  {
    label: "ad_platform_click_id",
    value: "n/a",
    info: "The GCLID / ad platform identifier — can appear on multiple rows (same user clicking multiple brands). Not used as the unique key for counting.",
  },
  {
    label: "user_unique_id",
    value: "n/a",
    info: "Visitor identifier — may be empty for some traffic types. Not used for click counting.",
  },
];

const SourceAggregation = () => {
  return (
    <>
      <Stack mb={1}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 500,
            color: "#00000099",
            fontSize: "14px",
            textTransform: "uppercase",
            mb: 0.5,
          }}
        >
          Source & Aggregation
        </Typography>
        {details.map((item, index) => (
          <React.Fragment key={item.label}>
            <Typography
              fontSize={12}
              py={0.5}
              display={"flex"}
            >
              <Box
                component="span"
                sx={{
                  textTransform: "uppercase",
                  fontWeight: 400,
                  width: "30%",
                  display: "inline-block",
                }}
              >
                {item.label}
              </Box>
              <Box
                sx={{
                  width: "70%",
                }}
                flexDirection={"row"}
              >
                {item.value}
                <span
                  style={{
                    display: "block",
                    fontStyle: "italic",
                    fontSize: "8px",
                  }}
                >
                  {item.info}
                </span>
              </Box>
            </Typography>

            {index !== details.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </Stack>
    </>
  );
};

export default SourceAggregation;
